import * as h from "react";
import { i as g, b as p, E as v, x as l, a as m, d as f, c as x } from "../createReactComponent-58f9bea8.mjs";
import { n as d } from "../property-9daa16cd.mjs";
import { e as k } from "../class-map-2994e95e.mjs";
import { S as y } from "../slot-controller-fa97ce97.mjs";
var u = Object.defineProperty, b = Object.getOwnPropertyDescriptor, c = (t, r, n, i) => {
  for (var a, e = i > 1 ? void 0 : i ? b(r, n) : r, s = t.length - 1; s >= 0; s--)
    (a = t[s]) && (e = (i ? a(r, n, e) : a(e)) || e);
  return i && e && u(r, n, e), e;
}, _ = ((t) => (t.LIST = "list", t.SEGMENTED = "segmented", t))(_ || {});
class o extends v {
  constructor() {
    super(), this.title = "", this.variant = "list", this.slotController = new y(this, "header");
  }
  getHeader() {
    return this.slotController.test("header") ? l` <div class="header-slot">
        <slot name="header"></slot>
      </div>` : this.title ? l` <div class="header">${this.title}</div>` : m;
  }
  render() {
    return l`<div
      class="container ${k({ "container--variant_list": this.variant === "list", "container--variant_segmented": this.variant === "segmented" })}"
    >
      ${this.getHeader()}
      <div class="body">
        <slot></slot>
      </div>
    </div>`;
  }
}
o.styles = g`
    ${p(`:host .container .header{color:var(--exo-color-font);font-size:var(--exo-font-size-small);font-weight:var(--exo-font-weight-bold);line-height:var(--exo-line-height-heading);letter-spacing:-.01em;text-align:left}:host .container .body{text-align:left}:host .container.container--variant_list ::slotted(ex-footer-link){margin-top:var(--exo-spacing-small);display:block}:host .container.container--variant_segmented ::slotted(ex-footer-link){display:inline-block;position:relative;margin-right:var(--exo-spacing-standard)}:host .container.container--variant_segmented ::slotted(ex-footer-link):after{content:"|";position:absolute;top:0;right:calc(-1 * var(--exo-spacing-small));color:var(--exo-color-font-secondary)}:host .container.container--variant_segmented ::slotted(ex-footer-link:last-child){margin-right:0}:host .container.container--variant_segmented ::slotted(ex-footer-link:last-child):after{display:none}
`)}
  `, c([d()], o.prototype, "title", 2), c([d()], o.prototype, "variant", 2);
const E = f("ex-footer-link-group", o), $ = x({ tagName: "ex-footer-link-group", elementClass: o, react: h, events: {}, displayName: "ExFooterLinkGroup", registerWebComponent: E });
export {
  $ as ExFooterLinkGroup,
  _ as FooterLinkGroupVariant,
  E as register
};
